var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-modal',{attrs:{"hide-secondary-button":true,"primary-button-label":"Crear distribuidor","modal-title":"Crear distribuidor"},on:{"closeModal":_vm.onCloseModal,"primaryButtonClick":_vm.onSave}},[_c('div',{staticClass:"content"},[_c('dealers-form',{ref:"form"})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26fc5b06","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/app/dealers/dealers-create-view.vue
// module id = null
// module chunks = 